import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-switch",
  "use": "icon-switch-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-switch\"><defs><style type=\"text/css\"></style></defs><path d=\"M39.2 414.5c0-22.6 18.3-41 41-41h859.3c22.6 0 41 18.3 41 41 0 22.6-18.3 41-41 41H80.2c-22.6-0.1-41-18.4-41-41zM39.2 614.4c0-22.6 18.3-41 41-41h859.3c22.6 0 41 18.3 41 41 0 22.6-18.3 41-41 41H80.2c-22.6 0-41-18.4-41-41z\" fill=\"#242424\" p-id=\"2168\" /><path d=\"M715.1 838.8c-16-16-16-41.9 0-57.9l195.4-195.4c16-16 41.9-16 57.9 0s16 41.9 0 57.9L773 838.8c-16 16-41.9 16-57.9 0zM51.2 443.4c-16-16-16-41.9 0-57.9l195.4-195.4c16-16 41.9-16 57.9 0s16 41.9 0 57.9L109.1 443.4c-16 16-41.9 16-57.9 0z\" fill=\"#242424\" p-id=\"2169\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/switch.svg
// module id = qyXC
// module chunks = 4